<div class="modal-container">
  <!-- Modales que se muestran varios a la vez -->
  <ng-container *ngFor="let modal of modals; let i = index">
    <mat-card [ngClass]="{ 'active-modal': i === activeModalIndex }" class="modal-box p-0 montserrat-font border-radius-5 {{
        modal.render.data.properties?.customClass ?? ''
      }}" cdkDrag [cdkDragFreeDragPosition]="modal" (cdkDragEnded)="onDragEnded($event)">
      <div class="handle-container">
        <div class="handle d-none d-md-block"></div>
      </div>
      <mat-card-title SheetBottom classContainer="modal-box" [breakPoint]="[0.01, 0.5]"
        class="d-flex full-width bg-color-background-1 justify-end modal-header-title mb-0 border-radius-t-5"
        (mousedown)="modalSelect(i)">
        <section class="d-flex full-width align-items-center cursor-move modal-header">
          <div cdkDragHandle class="flex-grow full-height d-flex fd-row header-modal">
            <div class="left-title-block bg-color-primary-1 border-radius-tl-5 d-md-none"></div>
            <ng-container *ngIf="modal.render.data.properties.icon">
              <div class="pl-1">
                <sit-icon [icon]="modal.render.data.properties.icon" alt="modal.render.data.properties.alt"
                  [sizeClass]="'icon-size-32'"></sit-icon>
              </div>
            </ng-container>
            <div
              class="text-ellipsis d-flex align-items-center flex-grow text-weight-600 text-size-22 ml-16 text-md-size-18 text-color-secondary-1 py-04">
              <span>
                {{
                modal.render.data.properties.titleModal
                ? modal.render.data.properties.titleModal
                : modal.render.data.properties.title
                }}
              </span>
            </div>
            <div class="mt-10-px mr-8">
              <sit-icon-button [alt]="'Cerrar'" [icon]="Icon.close_x" (click)="deleteModal(i)" sizeClass="icon-size-20"
                color="withe"></sit-icon-button>
            </div>
          </div>
        </section>
      </mat-card-title>
      <mat-card-content class="bg-color-background-3 border-radius-b-5 ">
        <sit-renderer class="full-width" [toRender]="modal.render"></sit-renderer>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <!-- Modal que se muestra en una instancia única y es de fondo blanco -->
  <ng-container *ngIf="uniqueModal$ | async as modal">
    <ng-container *ngIf="modal">
      <div class="modal-overlay">
        <div class="modal" [ngClass]="{ 'sheet-bottom-modal': modal.sheetBottom }">
          <div class="modal-content-box d-flex fd-row">
            <div class="left-modal-line" [ngClass]="modal.leftLineClass ?? 'bg-white'"></div>
            <div class="box-content">
              <ng-container *ngIf="!modal.isLogginUserModal">
                <div
                  class="modal-header active-modal d-flex full-width justify-end modal-header-height mb-0 border-radius-t-8"
                  [ngClass]="modal.headerBackgroundClass ?? 'bg-white'">
                  <div class="d-flex full-width full-height align-items-center">
                    <div class="flex-grow full-height d-flex fd-row">
                      <!-- <div class="left-title-block bg-color-primary-1 border-radius-tl-5" [ngClass]="modal.modalClass">
                      </div> -->
                      <ng-container *ngIf="modal.icon">
                        <div class="pl-1">
                          <sit-icon [icon]="modal.icon" alt="modal?.alt" [sizeClass]="'icon-size-34'"></sit-icon>
                        </div>
                      </ng-container>
                      <div
                        class="d-flex align-items-center flex-grow text-weight-600 text-size-16 ml-16 text-md-size-18"
                        [ngClass]="
                          modal.headerBackgroundClass
                            ? 'text-color-secondary-2'
                            : 'text-color-background-2'
                        ">
                        <h2>{{ modal.title }}</h2>
                      </div>
                    </div>
                    <sit-icon-button (click)="closeUniqueModal()" [icon]="Icon.close_ng" alt="Cerrar" [ngClass]="
                        modal.headerBackgroundClass
                          ? 'text-color-secondary-2'
                          : 'text-color-background-2'
                      "></sit-icon-button>
                  </div>
                </div>
              </ng-container>
              <div class="modal-body">
                <sit-renderer [toRender]="modal.toRender"></sit-renderer>
              </div>
              <ng-container *ngIf="modal.confirm || modal.cancel">
                <div class="modal-actions align-self-center"
                  [ngClass]="modal.footerBackgroundClass ?? 'bg-color-background-3'">
                  <ng-container *ngIf="modal.cancel && !modal?.hideCancelButton">
                    <sit-button (click)="dialogAction(modal.cancel)"
                      [buttonProperties]="cancelButtonProps"></sit-button>
                  </ng-container>
                  <ng-container *ngIf="modal.confirm">
                    <sit-button (click)="dialogAction(modal.confirm)"
                      [buttonProperties]="confirmButtonProps"></sit-button>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>